<template>
    <div class="dialogBox">
        <el-dialog title="发车单明细"
                   :modal="false"
                   @close="handleClose"
                   width="80%"
                   :visible.sync="dialogCTableVisible">
            <!-- header -->
            <div class="titleInfo">
                <div class="header-left">
                    <span>发车单：<span class="content">{{cpNoandLineName.dispatchNo || '--'}} </span></span>
                    <span>线路：<span class="content">{{obj.lineName || '--'}} </span></span>
                    <span>重量：<span class="content">{{taskTotalWeight}} Kg</span></span>
                    <span>体积：<span class="content">{{taskTotalVolume}} m³</span></span>
                    <span>货值：<span class="content">{{taskTotalOrderValue}} 元</span></span>
                    <span>包装数：<span class="content">{{taskTotalPackageQuantity}}</span></span>
                    <el-button type="primary" @click="productBtn">商品明细
                    </el-button>
                </div>
                <div class="header-right"
                     v-if="paginationTableData.length > 0 && +obj.dispatchStatus<=30">
                    <div class="btn-content">
                        <el-button type="primary"
                                   @click="handleAdd">加单</el-button>
                    </div>
                    <div class="btn-content">
                        <el-button type="primary"
                                   @click="handleTrans">转移</el-button>
                    </div>
                    <div class="btn-content">
                        <el-button type="primary"
                                   @click="handleMove">移除</el-button>
                    </div>
                </div>
            </div>
            <!-- table -->
            <el-table :data="paginationTableData"
                      @select="selectRow"
                      @select-all="selectAll"
                      v-loading="loading"
                      border
                      style="width: 100%">
                <el-table-column type="selection">
                </el-table-column>
                <el-table-column label="序号"
                                 type="index" />
                <el-table-column v-for="(item, index) in tableConfig.table.columns"
                                 :width="item.width"
                                 :key="index"
                                 show-overflow-tooltip
                                 :label="item.label"
                                 :prop="item.prop">
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination :current-page.sync="currentPage"
                               :page-size="pageSize"
                               :total="tableData.length"
                               class="table-pagination"
                               layout="total, prev, pager, next"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange">
                </el-pagination>
            </div>

        </el-dialog>
        <!-- 加单 -->
        <train-adjust-task-add ref="taskAdditionDialog"
                               :QCO="QCO"
                               @tasksToAdd="tasksToAdd"></train-adjust-task-add>
        <!-- 转移 -->
        <el-dialog title="转移"
                   :visible.sync="transferVisible"
                   width="40%"
                   @close="transClose"
                   append-to-body>
            <el-radio v-model="identify"
                      label="1"
                      @change="transferLabelChange">已有发车单
                <el-select style="width: 230px;"
                           v-model="cpNoLineName"
                           filterable
                           @focus="handleSelChange"
                           :filter-method="transTreeFilterMethod"
                           clearable>
                    <el-option v-for="(item, index) in transTreeLimit"
                               :key="'dispatchNo' + index"
                               :label="item.cpNoLineName"
                               :value="item.cpNoLineName"></el-option>
                </el-select>
            </el-radio>
            <el-radio v-model="identify"
                      label="2"
                      @change="transferLabelChange">新建发车单</el-radio>
            <div slot="footer"
                 class="dialog-footer">
                <el-button @click="transClose">取 消</el-button>
                <el-button type="primary"
                           :loading="saveLoading"
                           :disabled="isDisable"
                           @click="handleSubmit">确
                    定</el-button>
            </div>
        </el-dialog>
        <!-- 排车 -->
        <car-scheduling-dialog v-if="isArrangeSubmitVisi"
                               append-to-body
                               ref="carScheduling"
                               :carrierDisabled="true"
                               :RwCarVisiable.sync="isArrangeSubmitVisi"
                               :taskDataList="selectTableData"
                               label-task="right"
                               @AdmittOk="handleArrangeSubmitOk">
        </car-scheduling-dialog>
        <!-- 快消单排车 -->
        <quick-cancellation-dialog :quickCancellationVisiable.sync="quickCancellationVisiable"
                                   v-if="quickCancellationVisiable"
                                   ref="quickDialog"
                                   :appendToBody='true'
                                   @AdmittOk="handleArrangeSubmitOk">
        </quick-cancellation-dialog>
        <DetailDialog :detailVisible.sync="rowDetailVisible"
                      :detailList="rowDtailData" />
    </div>
</template>
<script>
import { departDetailsConfig } from './config';
import CarSchedulingDialog from '@/modules/transport/otp/components/dialog/carSchedulingDialog';
import TrainAdjustTaskAdd from '../trainAdjustTaskAdd/TrainAdjustTaskAdd';
import QuickCancellationDialog from '@/modules/transport/otp/components/dialog/QuickCancellationDialog';
import DetailDialog from './DetailDialog';
import * as api from '../../../../api/visualMapLayout';
import { rowCarCheck, addOrderCheck, minusVerifyLBXOrder, appointmentCheck, verifyLBX } from '@/modules/transport/otp/utils/dispatchCenter.js';
import { dictWithUrl } from '@/components/lots/api.js';

const PRIVILEGE_MOVE_CODE = 'otp040100016';

export default {
    name: 'depart-details-dialog',
    components: {
        TrainAdjustTaskAdd,
        CarSchedulingDialog,
        QuickCancellationDialog,
        DetailDialog
    },
    props: {
        obj: {
            type: Object,
            default () {
                return {};
            }
        },
        appointmentSiteCodeWhiteList: {
            type: Array,
            default () {
                return [];
            }
        },
    },
    data () {
        return {
            dialogCTableVisible: false,
            transferVisible: false,
            rowDetailVisible: false,
            tableConfig: departDetailsConfig,
            currentPage: 1,
            pageSize: 10,
            dispatchNo: '',
            cpNoLineName: '', // 转移的发车单号
            identify: '',
            transTreeFilter: [], // 转移可选发车单
            taskAddDataList: [], // 加单选中数据
            selectTableData: [], // 移除单选中的表格
            tableData: [], // 表格数据
            rowDtailData: [], // 表格数据
            transferVisi: false,
            isArrangeSubmitVisi: false, // 排车
            isDisable: false,
            loading: true,
            saveLoading: false,
            value: '',
            QCO: '',
            companyType: {},
            quickCancellationVisiable: false,
        };
    },
    computed: {
        // 重量
        taskTotalWeight: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        // 体积
        taskTotalVolume: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        // 货值
        taskTotalOrderValue: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalOrderValue = partical + (value.orderValue || 0);
                return Math.round(taskTotalOrderValue * 1000000) / 1000000;
            }, 0);
        },
        //包装数
        taskTotalPackageQuantity: function () {
            return this.tableData.reduce((partical, value) => {
                const taskTotalPackageQuantity = partical + (value.totalPackageQuantity || 0);
                return Math.round(taskTotalPackageQuantity * 100) / 100;
            }, 0);
        },
        paginationTableData () {
            const s = this.pageSize;
            const i = this.currentPage - 1;
            return this.tableData.slice(s * i, s * (i + 1));
        },
        transTreeLimit: function () {
            if (this.transTreeFilter.length < 10) {
                return this.transTreeFilter;
            } else {
                return this.transTreeFilter.slice(0, 10);
            }
        },
        cpNoandLineName () {
            return this.tableData[0] || {};
        },
        isPrivilege: function () { // 加入发车单/移除发车单 时使用，特权模式
            const auths = this.$_has(PRIVILEGE_MOVE_CODE);
            return auths;
        }
    },
    methods: {
        // 引入字典处理字段
        async getDictList () {
            const res = await dictWithUrl('SYS_PROFESSIONAL_COMPANY');
            if (res && +res.code === 0) {
                const { SYS_PROFESSIONAL_COMPANY } = res.data;
                this.companyType = SYS_PROFESSIONAL_COMPANY;
            }
        },
        // 发车单明细
        async getData (dispatchNo) {
            this.loading = true;
            const res = await api.getDispatchDetails({
                dispatchNo
            });
            if (res && +res.code === 0) {
                this.loading = false;
                res.data.forEach(v => {
                    v['professionalCompanyName'] = this.companyType[v.professionalCompany] || '';
                    v.planOrderFlagName = +v.planOrderFlag === 1 ? '是' : '否';
                });
                this.tableData = res.data || [];
            }
        },

        handleSizeChange (val) {
            this.pageSize = val;
        },
        handleCurrentChange (val) {
            this.currentPage = val;
        },
        show () {
            this.dialogCTableVisible = true;
        },
        handleClose () {
            this.$emit('resetData'); // 关闭弹框 统一更新发车单列表
            this.selectTableData = [];
            this.cpNoLineName = '';
        },
        // 加单
        handleAdd () {
            // 快消单加单 加开关
            this.QCO = 'QCO';
            this.$refs.taskAdditionDialog.open();
        },
        // 选中数据加单
        tasksToAdd (taskList) {

            if (!taskList.length) {
                return this.$message.warning('请至少勾选一条数据');
            }
            const rows2Transfer = taskList;
            if (+this.obj.dispatchStatus >= 40) {
                for (let i = 0; i < rows2Transfer.length; i++) {
                    if (rows2Transfer[i].logisticMode === 'WT') return this.$message.warning('发车单不是在途前的状态，不允许加仓配分离订单');
                }
            }
            if (this.isPrivilege && rows2Transfer.some(item => item.logisticMode === 'WT') && rows2Transfer.some(item => item.scanNum > 0) && rows2Transfer.every(item => +item.dispatchType !== 0)) {
                return this.$message.warning('直通宝已扫码，请在直通宝完成后续操作');
            }
            let rowCarCheckRes = '';
            rowCarCheckRes = rowCarCheck(this.paginationTableData);

            if (!rowCarCheckRes) rowCarCheckRes = rowCarCheck(rows2Transfer, this.paginationTableData[0], this.paginationTableData);

            if (!rowCarCheckRes) rowCarCheckRes = addOrderCheck(this.paginationTableData, rows2Transfer);

            if (rowCarCheckRes) {
                return this.$message.warning(rowCarCheckRes);
            }
            let verifyLBXRes = verifyLBX(rows2Transfer, this.paginationTableData);
            const customerOrderNoList = appointmentCheck(verifyLBXRes, this.appointmentSiteCodeWhiteList);
            if (customerOrderNoList.length) {
                return this.$message.warning(`以下客户订单号需要先预约才能排车:${customerOrderNoList}`);
            }
            this.taskAddDataList = taskList;
            this.addAndmoveTask(taskList, { id: 'add' });

        },
        selectAll (row) {
            this.selectRow(row);
        },
        selectRow (row) {
            this.selectTableData = row;
        },
        //  批量移除功能
        handleMove () {
            const cheList = this.selectTableData;
            if (cheList.length === 0) return this.$message.warning('请至少勾选一条数据');
            if (+this.obj.gainingContract) {
                this.$message.warning('获取合同号中，不可以加单');
            } else {
                for (let i = 0; i < cheList.length; i++) {
                    if (cheList[i].logisticMode !== 'WT' && +cheList[i].taskStatus === 30 && cheList[i].dispatchNo &&
                        (cheList[i].inOutType === 'OUT' || cheList[i].inOutType === 'YS')) {
                        return this.$message.warning(`存在不能减单的运输单：${cheList[i].taskNo}`);
                    }
                    if (this.isPrivilege && cheList[i].logisticMode === 'WT' && cheList[i].taskStatus >= 40) {
                        return this.$message.warning(`仓配分离运输单：${cheList[i].taskNo} 是在途前的状态才能减单`);
                    }
                }
            }
            const taskNoList = cheList.map(v => v.taskNo);
            const taskList = this.tableData.filter(item => {
                // 判断每个对象的taskNo是否在需要删除的列表中
                return !taskNoList.includes(item.taskNo);
            });
            this.addAndmoveTask(taskList, { id: 'move' });
        },
        // 加单/移除订单操作
        async addAndmoveTask (taskList, flag) {
            const params = {
                dispatchNo: this.cpNoandLineName.dispatchNo,
                transportList: flag.id === 'move' ? taskList : this.tableData.concat(taskList),
                preDispatchType: 1, // 1人工调度
                // carrierCode  承运商编码
                // 地图排车加减单默认非直控线路
                directlyControlledRecord: {
                    reasonDialogVisible: false,
                    directControlTransportCapacityFlag: false
                },
                operateSystem: 'LSP',
                operateEntrance: 'LSP'
            };
            params.carrierCode = params.transportList.length ? params.transportList[0].carrierCode : '';
            await api.updateCarArrange(params).then(res => {
                if (res && +res.code === 0) {
                    const message = res.msg !== 'Success' ? `${res.msg}` : '操作成功';
                    this.$message.success(`${message}`);
                    this.$refs.taskAdditionDialog.close();
                    this.taskAddDataList = [];
                    this.getData(this.cpNoandLineName.dispatchNo);
                }
            });
        },
        transTreeFilterMethod (val) {
            this.cpNoLineName = val;
            this.$nextTick(() => {
                this.getTargetList();
            });
        },
        handleSelChange () {
            this.getTargetList();
            this.identify = '1';
        },
        // 获取可转移的cp单号
        getTargetList () {
            const params = {
                dispatchStatusList: ['6', '10', '20', '30'],
                siteCodeList: this.$attrs.siteList,
                dispatchNo: this.cpNoLineName.trim(), // CP单精准搜索
                operateSystem: 'LSP'//区分系统
            };
            api.getTargetRoot(params).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data.list.filter(v => v.dispatchNo !== this.cpNoandLineName.dispatchNo);
                    // cp单 拼接四级地址
                    const arrNew = data.map(v => {
                        return { cpNoLineName: v.lineName ? `${v.dispatchNo}-${v.lineName}` : v.dispatchNo };
                    });
                    const result = data.map((item, index) => {
                        return { ...item, ...arrNew[index] };
                    });

                    this.transTreeFilter = result;
                }
            });
        },
        // 转移单
        handleTrans () {
            const cheList = this.selectTableData;
            if (cheList.length === 0) return this.$message.warning('请至少勾选一条数据');
            if (+this.obj.gainingContract === 1) return this.$message.warning('正在获取合同号中，不能转移');
            for (let i = 0; i < cheList.length; i++) {
                if (+cheList[i].taskStatus === 30 && ['YS', 'OUT'].includes(cheList[i].inOutType) &&
                    cheList[i].sourceSystem === 'CIMS' && +cheList[i].distributionNum === 1 && cheList[i].orderSource === 'API') {
                    return this.$message.warning(`存在不能转移的运输单：${cheList[i].taskNo}`);
                }
                if (cheList[i].planOrderFlag !== cheList[0].planOrderFlag) return this.$message.warning('模糊和非模糊订单不能一起转移');
            };
            this.transferVerifyLBXOrderRes = minusVerifyLBXOrder(cheList, this.paginationTableData);
            this.transferVisible = true;
        },
        // 关闭转移弹窗
        transClose () {
            this.transTreeFilter = [];
            this.dispatchNo = '';
            this.identify = '';
            this.transferVisible = false;
        },
        // 新建发车单弹框保存
        handleArrangeSubmitOk (formName) {
            if (!formName.state) return
            const params = {
                flag: 2,
                transportList: this.selectTableData,
                preDispatchType: 1,
                oldDispatchNo: this.cpNoandLineName.dispatchNo,
                ...formName.data,
                mapDispatch: true,
                operateSystem: 'LSP',
            };
            // 快消预排加传
            if (this.quickCancellationVisiable) {
                params.carrierCode = this.selectTableData[0].carrierCode
                params.carrierName = this.selectTableData[0].carrierName
                params.procurementChannel = this.selectTableData[0].procurementChannel      
            }
            api.getTransferData(params).then(res => {
                if (res && +res.code === 0) {
                    const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: `<div>
                                    <span>已保存，生成发车单号：${res.data}</span>
                                    <a id="copyNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                </div>`,
                        type: 'success',
                        duration: 5000
                    });
                    this.isArrangeSubmitVisi = false;
                    this.quickCancellationVisiable = false;
                    document.getElementById('copyNo').addEventListener('click', () => {
                        this.copyText(document.body, genDispatchNo, false);
                    });
                } else if (+res.code === 200) {
                    this.isArrangeSubmitVisi = false;
                    this.quickCancellationVisiable = false;
                    this.$message.error(res.msg || '');
                }
                this.getData(this.cpNoandLineName.dispatchNo);
            }).catch(() => {
                this.mainLoading = false;
            });
        },
        //    转移确认
        handleSubmit () {
            if (+this.identify === 1) {
                this.handleTransSubmit(this.identify);
            } else { this.transferVisi = false; }
        },
        // 已有发车单label =1
        handleTransSubmit (flag) {
            if (!this.cpNoLineName.trim()) {
                return this.$message.warning('请选择发车单号！');
            }
            this.checkSuNingTransfer(flag);
        },
        // copy
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            cellEl.appendChild(input);
            input.select();
            document.execCommand('copy');
            cellEl.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        // 已有发车单确认
        checkSuNingTransfer (flag) {
            this.saveLoading = true;
            const obj = {
                flag,
                oldDispatchNo: this.cpNoandLineName.dispatchNo, // 原有的CP单
                newDispatchNo: this.cpNoLineName.split('-')[0], // 选中的CP单
                transportList: this.selectTableData,
                carrierCode: this.selectTableData.carrierCode,
                operateEntrance: 'LSP',
                preDispatchType: 1 // 人工调度
            };
            api.getTransferData(obj).then(res => {
                this.isDisable = true;
                if (res && +res.code === 0) {
                    this.saveLoading = false;
                    this.handleCancel();
                    const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: `<div>
                                <span>转移成功，生成发车单号：${res.data}</span>
                                <a id="copyTraCNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                            </div>`,
                        type: 'success',
                        duration: 3000
                    });
                    document.getElementById('copyTraCNo').addEventListener('click', () => {
                        this.copyText(document.body, genDispatchNo, false);
                    });
                    this.isDisable = false;
                    this.transferVisible = false;
                    this.getData(this.cpNoandLineName.dispatchNo);
                } else {
                    this.saveLoading = false;
                    this.isDisable = false;
                };
            }).catch(() => {
                this.isDisable = false;
                this.saveLoading = false;
            });
        },

         // 商品明细按钮
        productBtn (data) {
            if (!this.selectTableData.length) {
                return this.$message.warning('请先勾选运输单');
            }
            this.rowDtailData = [];
            this.rowDtailData = this.selectTableData;
            this.rowDetailVisible = true;
        },

        handleCancel () {
            this.transferVisi = false;
            this.identify = '';
            this.value = '';
        },
        // 已有/新建发车单 label=2 新建发车单
        transferLabelChange (label) {
            if (label === '2') {
                // 如果车牌不存在 走排车规划
                if (this.obj.vehicleCard === '*') {
                    this.transferVisible = false;
                    this.quickCancellationVisiable = true;
                } else {
                    this.isArrangeSubmitVisi = true;
                    const params = {
                        carrierName: this.selectTableData[0].carrierName,
                        carrierCode: this.selectTableData[0].carrierCode,
                        supplierCode: this.selectTableData[0].carrierCode,
                        transType: this.selectTableData[0].procurementChannel,
                        tranName: this.selectTableData[0].procurementChannelName,
                        siteCode: this.selectTableData[0].siteCode,
                        transUnitName: this.selectTableData[0].transUnitName,
                        transUnitCode: this.selectTableData[0].transUnitCode,
                        paymentTerms: this.selectTableData[0].paymentTerms,
                        transportContractNo: this.selectTableData[0].transportContractNo
                    };
                    this.$nextTick(() => {
                        this.$refs.carScheduling.AdmittRuleForm.carrierName = this.selectTableData[0].carrierName;
                        this.$refs.carScheduling.AdmittRuleForm.companyCode = this.selectTableData[0].companyCode;
                        this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.selectTableData.filter(item => item.lineCode).map(item => item.lineCode);
                        this.$refs.carScheduling.AdmittRuleForm.siteCodeList = this.selectTableData.filter(item => item.siteCode).map(item => item.siteCode);
                        this.$refs.carScheduling.getAdvanceValueLists(params);
                        this.transClose();
                    });
                }
            }
        }
    },
    created () {
        this.getDictList();
    }
};
</script>
<style lang="less" scoped>
.dialogBox {
    .titleInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;

        .header-left {
            color: #8c919c;
            font-size: 13px;

            .content {
                color: #333333;
                padding-right: 10px;
            }
        }

        .header-right {
            display: flex;
            justify-content: space-between;

            .btn-content {
                margin-right: 10px;
            }
        }
    }

    .el-dialog__body {
        padding: 5px;
    }

    .block {
        height: 30px;
        padding-top: 10px;

        .table-pagination {
            text-align: right;

            .btn-prev,
            .btn-next,
            .el-pager li {
                background-color: #ffffff !important;
                border: 1px solid #cccccc;
                border-radius: 4px !important;
                padding: 0;
                min-width: 30px;
                margin-right: 4px;
            }

            .el-pager li.active + li {
                border-left: 1px solid #cccccc;
            }
        }
    }
}
</style>
